import React from 'react'
import {Trans} from 'react-i18next'

const AcknowledgeTermsAndConditions = (): React.ReactElement => (
    <small className='text-muted'>
        <Trans>By using Ninchat you accept the <a href='../terms' rel='license' target='_blank'>Terms</a> and <a href='../privacy' rel='license' target='_blank'>Privacy policy</a></Trans>
    </small>
)

export default AcknowledgeTermsAndConditions
